/* Highlights (Pashion): in the mobile slider, size every button-style
 * highlight to the widest label so the chips are uniform. Sets --chip-width on
 * .highlights__items--mobile-slider; the CSS falls back to auto width. */
(function () {
  'use strict';

  var MOBILE_MAX = 749;

  function equalize(list) {
    list.style.removeProperty('--chip-width');
    if (window.innerWidth > MOBILE_MAX) return;
    var max = 0;
    list.querySelectorAll('.highlights__item--button .btn').forEach(function (btn) {
      max = Math.max(max, btn.getBoundingClientRect().width);
    });
    if (max) list.style.setProperty('--chip-width', Math.ceil(max) + 'px');
  }

  function init() {
    document.querySelectorAll('.highlights__items--mobile-slider').forEach(equalize);
  }

  init();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(init);

  var timer;
  window.addEventListener('resize', function () {
    clearTimeout(timer);
    timer = setTimeout(init, 150);
  });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('theme:highlights:updated', init);
})();
